export default __webpack_public_path__ + "static/media/small.321e3201.jpg";